import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const memberEventOffer = gql`
  fragment Become_a_member_Member_event_offer on Become_a_memberBodyMembereventoffer {
    type
    primary {
      offer_title
      offer_banner_color
      offer_link {
        ...documentLink
        ...externalLink
      }
    }
    fields {
      offer_text
      offer_condition
      offer_percentage
      offer_items
    }
  }
  ${externalLink}
  ${documentLink}
`;
